import axios from 'axios';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_REPRESENTANTS_REQUEST: 'FETCH_REPRESENTANTS_REQUEST',
    FETCH_REPRESENTANTS_SUCCESS: 'FETCH_REPRESENTANTS_SUCCESS',
    FETCH_REPRESENTANTS_FAILURE: 'FETCH_REPRESENTANTS_FAILURE',

    FETCH_SUGGESTIONS_REPRESENTANT_REQUEST: 'FETCH_SUGGESTIONS_REPRESENTANT_REQUEST',
    FETCH_SUGGESTIONS_REPRESENTANT_SUCCESS: 'FETCH_SUGGESTIONS_REPRESENTANT_SUCCESS',
    FETCH_SUGGESTIONS_REPRESENTANT_FAILURE: 'FETCH_SUGGESTIONS_REPRESENTANT_FAILURE',

    CLEAR_SUGGESTIONS_REPRESENTANT: 'CLEAR_SUGGESTIONS_REPRESENTANT',

    SET_REPRESENTANT_VALUE: 'SET_REPRESENTANT_VALUE',
    CLEAR_REPRESENTANT_VALUE: 'CLEAR_REPRESENTANT_VALUE'
};

/**
 * FETCH_REPRESENTANTS
 * ActionCreator pour la récupération des représentants
 */
const fetchRepresentantsRequest = () => ({ type: Actions.FETCH_REPRESENTANTS_REQUEST });
const fetchRepresentantsSuccess = items => ({ type: Actions.FETCH_REPRESENTANTS_SUCCESS, items });
const fetchRepresentantsFailure = error => ({ type: Actions.FETCH_REPRESENTANTS_FAILURE, error });

export const fetchRepesentants = () => (dispatch, getState) => {
    if (getState().repesentant.repesentants.isLoading) {
        return;
    }
    if (getState().repesentant.repesentants.items.length > 0) {
        return;
    }
    return dispatch(_fetchRepresentants());
};

const _fetchRepresentants = () => async (dispatch) => {

    dispatch(fetchRepresentantsRequest());

    try {
        let response = await axios.get('api/repesentants');
        dispatch(fetchRepresentantsSuccess(response.data));
    } catch (error) {
        console.error('fetchRepesentants : ', error);
        dispatch(fetchRepresentantsFailure(error));
    }
};

/**
 * ActionCreator pour FETCH_SUGGESTIONS_...
 */
const fetchSuggestionsRepresentantRequest = (namespace) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_REPRESENTANT_REQUEST}`
});
const fetchSuggestionsRepresentantSuccess = (namespace, representants) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_REPRESENTANT_SUCCESS}`,
    representants
});
const fetchSuggestionsRepresentantFailure = (namespace, error) => ({
    type: `${namespace}/${Actions.FETCH_SUGGESTIONS_REPRESENTANT_FAILURE}`,
    error
});

/**
 * ActionCreator pour la récuperation des données (suggestions)
 */
export const fetchSuggestionsRepresentant = (namespace, searchValue) => async (dispatch) => {
    dispatch(fetchSuggestionsRepresentantRequest(namespace));

    try {
        let response = await axios.get('api/representants/suggestion?query=' + searchValue);

        dispatch(fetchSuggestionsRepresentantSuccess(namespace, response.data));

    } catch (error) {
        dispatch(fetchSuggestionsRepresentantFailure(namespace, error));
    }
};

/**
 * ActionCreator pour CLEAR_SUGGESTIONS_REPRESENTANT
 */
export const clearSuggestionsRepresentant = (namespace) => ({ type: Actions.CLEAR_SUGGESTIONS_REPRESENTANT });

/**
 * ActionCreator pour SET_REPRESENTANT_VALUE
 */
export const setRepresentantValue = (namespace, value, selectedCode) => ({ type: `${namespace}/${Actions.SET_REPRESENTANT_VALUE}`, value, selectedCode });

/**
 * ActionCreator pour CLEAR_REPRESENTANT_VALUE
 */
export const clearRepresentantValue = (namespace) => ({ type: `${namespace}/${Actions.CLEAR_REPRESENTANT_VALUE}` });
